/**
 * Villkorsversion. Höj versionen när villkoren ändras – då måste alla
 * användare godkänna på nytt vid nästa inloggning.
 */
export const TERMS_VERSION = "2026-08-16";

export const COPYRIGHT_LINE =
  "© Byggarbetsmiljökontrollen. Mall, struktur och frågeunderlag tillhör Byggarbetsmiljökontrollen och får inte kopieras, säljas vidare eller återanvändas utanför tjänsten.";
